import './index.less';
import React, { useEffect, useState } from 'react';
import AlertIcon from './assets/alert-circle-filled.svg';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import { hasFeatureFlag } from '@/services';
import { getActiveSummary, getWarningSummary } from './actions';
import CGI from '@/api/operator/cgi/smb/account/gdt';

interface ThrowControlAlertProps {
  style?: {} | undefined;
  needShowConfirmAuthMessage?: boolean;
  agencyUid?: number[];
}

export default function ThrowControlAlert(props: ThrowControlAlertProps) {
  const { style = {}, needShowConfirmAuthMessage = false, agencyUid = [] } = props;

  const [accountList, setAccountList] = useState<any[]>([]);
  const [warningList, setWarningList] = useState<any[]>([]);
  const [isAllWarning, setIsAllWarning] = useState(true);
  const [customerContent, setCustomerContent] = useState('');
  const [showTips, setShowTips] = useState(false);
  const [unsetCount, setUnsetCount] = useState<number>(0);
  const [date, setSetDate] = useState<string>('');

  const setAccount = () => {
    window.open(`${REACT_APP_PUBLIC_URL}/agency/credit-system`);
  };

  const viewDoc = () => {
    window.open('https://doc.weixin.qq.com/doc/w3_AJoAcQaaACgCN6k72fRxNR4Gk0zlq?scode=AJEAIQdfAAoWOLF6wLAJoAcQaaACg&isEnterEdit=1');
  };

  const handleBatchSetAuth = () => {
    const baseUrl = `${REACT_APP_PUBLIC_URL}/agency/advertiser-list/tencent`;
    const params = encodeURIComponent(JSON.stringify({
      customer_status: 'CUSTOMERSTATUS_NORMAL',
    }));
    const url = `${baseUrl}?page_type=confirm_auth&params=${params}`;
    window.location.href = url;
  };

  const handleViewGuide = () => {
    // TODO: 查看详细指引跳转逻辑
    window.open(
      'https://docs.qq.com/doc/DSWpxdFNJcGhaWU5q'
    );
  };

  useEffect(() => {
    Promise.all([getActiveSummary({}), getWarningSummary({})]).then(
      (res: any) => {
        const accountList = res[0]?.data?.list || [];
        const warningList = res[1]?.data?.ad_customer_list || [];
        console.log('length', accountList.length, warningList.length);
        setShowTips(
          accountList.length === 0 && warningList.length === 0 ? false : true
        );
        setAccountList(accountList);
        setWarningList(warningList);
      }
    );
  }, []);

  useEffect(() => {
    if (needShowConfirmAuthMessage) {
      const params: { agency_ids?: number[] } = {};
      if (agencyUid.length > 0) {
        params.agency_ids = agencyUid;
      }
      CGI.getCurrentUserStats(params).then((res: any) => {
        if (res?.code === 0) {
          setUnsetCount(res.data?.total_count || 0);
          setSetDate(res.data?.date || '');
        }
      });
    }
  }, [needShowConfirmAuthMessage, agencyUid.join(',')]);

  const initText = () => {
    let text = '';
    if (accountList.length > 0) {
      setIsAllWarning(false);
      if (warningList.length > 0) {
        // 部分受限
        text = `系统检测你有${accountList.length + warningList.length}个主体信誉等级低，其中${accountList.length}个主体已触达账户数限制，今日将限制可投的账户数，系统默认为你启用昨日花费较高的账户，你可于账户列表查看「账户是否启用」状态并`;
      } else {
        // 全部受限
        text = `系统检测你有${accountList.length ?? '-'}个主体信誉等级低且触达账户数限制，今日将限制可投的账户数，系统默认为你启用昨日花费较高的账户，你可于账户列表查看「账户是否启用」状态并`;
      }
    } else {
      setIsAllWarning(true);
      // 全部预警
      text = `系统检测你有${warningList.length ?? '-'}个主体信誉等级偏低，本周进入预警状态，若账户数达上限将触发可投账户数限制，请持续关注以免影响日后投放，你可至`;
    }
    setCustomerContent(text);
  };

  useEffect(() => {
    initText();
  }, [accountList, warningList]);

  if (!hasFeatureFlag('enable_account_red_line')) {
    return null;
  }

  return (
    <>
      {(showTips || (needShowConfirmAuthMessage && unsetCount > 0)) ? (
        <div className="throw-control-alert-container">
          <div className="throw-control-alert" style={style}>
            <span className="throw-control-alert__icon">
              <img src={AlertIcon} alt="警告" />
            </span>
            {showTips ? (
              <div className="throw-control-alert__content">
                {customerContent}
                {isAllWarning ? (
                  <>
                    <span onClick={setAccount}>信誉体系</span>查看详情
                  </>
                ) : (
                  <span onClick={setAccount}>调整启用账户</span>
                )}
                ，如有疑问可咨询对接腾讯广告运营或
                <span onClick={viewDoc}>查看详细文档</span>
              </div>
            ) : null}
            {needShowConfirmAuthMessage && unsetCount > 0 ? (
              <div className="throw-control-alert__content">
                系统检测你有{unsetCount}个在投子客账户未确认运营权,你可通过
                <span onClick={handleBatchSetAuth}>批量设置运营权</span>
                快速完成此设置将帮助平台为你提供更高效的账户管理能力,请于{date}前完成。感谢你的配合,如有疑问请联系腾讯广告销售运营经理或
                <span onClick={handleViewGuide}>查看详细指引</span>
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
}
